const loadFeatures = () => {
    window.loadCurrencyDropdown && window.loadCurrencyDropdown();
    window.mobAccordionMenu && window.mobAccordionMenu();
    window.intializeTable && window.intializeTable();
    window.statFlag && window.statFlag();
    window.verifyEmail && window.verifyEmail();
    window.ocrCallback && window.ocrCallback();
}
if (/complete|interactive|loaded/.test(document.readyState)) {
    loadFeatures();
} else {
    window.addEventListener("load", loadFeatures);
}